'use es6';

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectDashboardPermission } from 'dashboard-lib/public/permission/permission-selector';
export const useDashboardPermission = dashboardId => {
  const selector = useMemo(() => selectDashboardPermission(dashboardId), [dashboardId]);
  return useSelector(selector);
};